var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRefresh(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "1.Bace\u57FA\u7840/3.Icon\u56FE\u6807/\u5176\u4ED6/history\u5907\u4EFD") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "1.Bace\\u57FA\\u7840/3.Icon\\u56FE\\u6807/\\u5176\\u4ED6/history\\u5907\\u4EFD",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L16,0 L16,16 L0,16 L0,0 Z",
    id: "history-(Background)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2094812,8.00171041 C13.2094803,10.8633728 10.8498726,13.2100286 7.90581417,13.2100277 C5.44425893,13.2100277 3.39128232,11.5695276 2.7844733,9.35914373 L1.75097656,9.52778625 C2.44243342,12.2419147 4.93583679,14.251709 7.90581369,14.251709 C11.4102516,14.251709 14.2511625,11.4534903 14.2511625,8.00171089 C14.2511625,4.54993129 11.4102554,1.75170898 7.90581751,1.75170898 C5.8062191,1.75170898 3.94479585,2.7561332 2.78980708,4.30375814 L2.78980696,2.64486009 L1.75097656,2.64486009 L1.75097656,5.79135323 C1.75097656,6.06749582 1.97483426,6.2913537 2.25097656,6.2913537 L5.37759185,6.29135323 L5.37759185,5.24682903 L3.40454268,5.24682903 C4.3389554,3.77684879 5.99991751,2.7933898 7.90581703,2.79339039 C10.8498755,2.79339123 13.2094822,5.14004827 13.2094812,8.00171041 Z",
    id: "history",
    fill: "currentColor"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.0a861f9992e29d92aa257eafcb3411a4.svg";
export { ForwardRef as ReactComponent };